import React from 'react';
import { User, Mail, Phone, Calendar } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import AdminLayout from '../../components/AdminLayout';

const AdminUsers = () => {
  const { users, bookings } = useApp();

  const enriched = users.map((u) => ({
    ...u,
    bookingsCount: bookings.filter((b) => b.userEmail === u.email).length,
    totalSpent: bookings.filter((b) => b.userEmail === u.email).reduce((s, b) => s + b.total, 0),
  }));

  return (
    <AdminLayout title="Users">
      <p className="text-sm text-neutral-600 mb-5">All registered customers and cleaners.</p>

      <div className="bg-white border border-neutral-200 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-neutral-50 border-b border-neutral-200">
              <tr>
                <th className="text-left px-4 py-3 font-semibold text-neutral-700">User</th>
                <th className="text-left px-4 py-3 font-semibold text-neutral-700">Contact</th>
                <th className="text-left px-4 py-3 font-semibold text-neutral-700">Role</th>
                <th className="text-left px-4 py-3 font-semibold text-neutral-700">Bookings</th>
                <th className="text-left px-4 py-3 font-semibold text-neutral-700">Total spent</th>
                <th className="text-left px-4 py-3 font-semibold text-neutral-700">Joined</th>
              </tr>
            </thead>
            <tbody>
              {enriched.map((u) => (
                <tr key={u.id || u.email} className="border-b border-neutral-100 hover:bg-neutral-50">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-[#E8F5E9] flex items-center justify-center">
                        <User className="w-4 h-4 text-[#2E7D32]" />
                      </div>
                      <div>
                        <p className="font-semibold">{u.name}</p>
                        <p className="text-xs text-neutral-500 font-mono">{u.id || '-'}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-xs flex items-center gap-1"><Mail className="w-3 h-3" /> {u.email}</p>
                    {u.phone && <p className="text-xs text-neutral-500 flex items-center gap-1 mt-0.5"><Phone className="w-3 h-3" /> {u.phone}</p>}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-block text-xs font-bold px-2 py-1 rounded-full ${u.role === 'cleaner' ? 'bg-[#FFF3E0] text-[#EA580C]' : 'bg-[#E8F5E9] text-[#2E7D32]'}`}>
                      {u.role || 'customer'}
                    </span>
                  </td>
                  <td className="px-4 py-3 font-bold">{u.bookingsCount}</td>
                  <td className="px-4 py-3 font-bold text-[#EA580C]">₹{u.totalSpent.toLocaleString('en-IN')}</td>
                  <td className="px-4 py-3 text-xs text-neutral-500">
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {u.createdAt ? new Date(u.createdAt).toLocaleDateString() : '-'}</span>
                  </td>
                </tr>
              ))}
              {enriched.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-16 text-center text-neutral-500">No users registered yet. Users will appear here after signup.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminUsers;
